import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const GeneralSettings = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.generalSettings')} />;
};

export default GeneralSettings;
